import { baseUrl, verbiText } from "./env";

interface GetTranscriptUrlDto {
  uuid: string;
  isOrderingUser: boolean;
}

export function getTranscriptUrl({
  uuid,
  isOrderingUser,
}: GetTranscriptUrlDto) {
  return isOrderingUser
    ? `${baseUrl}/orders/${uuid}/transcript?isSpeaker=true`
    : `${verbiText}/?transcriptJobId=${uuid}&isSpeaker=true`;
}

interface GetAppQueryParamsDto {
  uuid: string;
  isOrderingUser: boolean;
}

export function getAppQueryParams({
  uuid,
  isOrderingUser,
}: GetAppQueryParamsDto) {
  return `?${isOrderingUser ? "orderId" : "transcriptJobId"}=${uuid}`;
}
